(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lic-gift-selection"]) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const data=JSON.parse(root.querySelector('[data-offer-data]').textContent);
    const isGift=root.dataset.mode==='gift';
    const live=root.dataset.live==='true';
    const route=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    const error=root.querySelector('[data-offer-error]');
    const status=root.querySelector('[data-cart-status]');
    const buyers=new Set(data.buyers.map(String)),gifts=new Set(data.gifts.map(String));
    async function readCart(){
      const response=await fetch(route+'cart.js',{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)throw new Error(data.error);
      return response.json();
    }
    function eligibility(cart){
      return {qualifies:cart.items.some(item=>buyers.has(String(item.product_id))),hasGift:cart.items.some(item=>gifts.has(String(item.product_id)))};
    }
    function showCart(cart){
      if(!isGift)return;
      const state=eligibility(cart);
      status.textContent=!live?data.preview:state.hasGift?data.existing:state.qualifies?data.ready:data.waiting;
      root.querySelectorAll('[data-gift-submit]').forEach(button=>button.disabled=!live||!state.qualifies||state.hasGift);
    }
    if(isGift)readCart().then(showCart).catch(()=>{status.textContent=data.error;});
    root.querySelectorAll('[data-offer-card]').forEach(card=>{
      const select=card.querySelector('select[name=id]');
      const image=card.querySelector('.lic-offer__image');
      const originalImage=image?{src:image.src,srcset:image.srcset}:null;
      const update=()=>{
        const option=select.selectedOptions[0];
        if(!option)return;
        card.querySelector('[data-card-price]').textContent=option.dataset.price;
        if(image&&option.dataset.image){image.removeAttribute('srcset');image.src=option.dataset.image;}
        else if(image&&originalImage){image.src=originalImage.src;image.srcset=originalImage.srcset;}
      };
      select.addEventListener('change',update);
    });
    const filter=root.querySelector('[data-size-filter]');
    if(filter)filter.addEventListener('change',()=>{
      let visible=0;
      root.querySelectorAll('[data-offer-card]').forEach(card=>{
        const select=card.querySelector('select[name=id]');
        const match=[...select.options].filter(option=>filter.value==='all'||option.dataset.fit===filter.value);
        card.hidden=match.length===0;
        if(!card.hidden){
          visible++;
          [...select.options].forEach(option=>{option.hidden=filter.value!=='all'&&option.dataset.fit!==filter.value;option.disabled=option.hidden;});
          if(!match.some(option=>option.selected))select.value=match[0].value;
          select.dispatchEvent(new Event('change'));
        }
      });
      root.querySelector('[data-offer-empty]').hidden=visible>0;
    });
    root.querySelectorAll('form.lic-offer__form').forEach(form=>form.addEventListener('submit',async event=>{
      event.preventDefault();
      const button=form.querySelector('button[type=submit]'),label=button.textContent;
      error.hidden=true;button.disabled=true;button.textContent=data.loading;
      try{
        if(isGift){const cart=await readCart();const state=eligibility(cart);if(!live||!state.qualifies||state.hasGift){showCart(cart);return;}}
        const payload={items:[{id:Number(new FormData(form).get('id')),quantity:1}]};
        const response=await fetch(route+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||data.error);
        window.location.assign(route+(isGift?'cart':'collections/complimentary-gifts'));
      }catch(e){error.textContent=e.message||data.error;error.hidden=false;}
      finally{button.textContent=label;if(isGift)readCart().then(showCart).catch(()=>{});else button.disabled=false;}
    }));
  }
  function initAll(){document.querySelectorAll('[data-lic-offer]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
